import { Stack, Text } from '@mantine/core';
import { StepRunLoadedInput } from '@/types/stepExecutions.ts';

const LoadedInputDetails = ({ input }: { input: StepRunLoadedInput }) => (
  <details style={{ overflowWrap: 'anywhere' }}>
    <summary>
      <Text component="span" size="xs" c="dimmed">
        {input.binding_count > 1 ? `${input.binding_count} bindings` : 'Binding details'}
      </Text>
    </summary>
    <Stack gap={3} mt={4}>
      {input.configured_roles.map((role) => (
        <Text key={`${role.group_key}-${role.input_index}`} size="xs">
          Configured for: {role.label}
          {input.configured_roles.filter((item) => item.group_key === role.group_key).length > 1 &&
            ` (input ${role.input_index + 1})`}
        </Text>
      ))}
      {input.configured_roles.length === 0 && (
        <Text size="xs" c="dimmed">
          Configured role evidence unavailable
        </Text>
      )}
      {input.data_input?.binding_name && (
        <Text size="xs">Binding name: {input.data_input.binding_name}</Text>
      )}
      {input.data_input && (
        <>
          <Text size="xs">Source type: {input.data_input.data_input_type}</Text>
          {Object.entries(input.data_input.config).map(([key, value]) =>
            value == null ? null : (
              <Text key={key} size="xs">
                {key.replaceAll('_', ' ')}:{' '}
                {typeof value === 'object' ? JSON.stringify(value) : String(value)}
              </Text>
            ),
          )}
        </>
      )}
    </Stack>
  </details>
);

export default LoadedInputDetails;
